const PageLoading = () => {
    return (
      <div className="w-full h-screen fixed inset-0 bg-white opacity-40 flex justify-center items-center">
        <div className="flex flex-col items-center">
          {/* Spinner */}
          <div className="w-16 h-16 border-4 border-[#BE007B] border-solid border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  };
  
  export default PageLoading;
  